// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__3EvM6","dark":"footer_dark__MW42V","services":"footer_services__BNo4T","policy_link":"footer_policy_link__2bHSr"};